import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, Typography, Fade } from "@mui/material";

// FullScreenLoader
// Props:
// - open (bool) : whether the loader is visible
// - text (string) : loading text to show under the spinner
// - overlayOpacity (number) : 0-1 opacity for the black overlay (default 0.6)
// - zIndex (number) : override zIndex if needed

export default function FullScreenLoader({
  open = true,
  text = "Loading",
  overlayOpacity = 0.6,
  zIndex,
}) {
  const overlayZ = typeof zIndex === "number" ? zIndex : 1300; // default above most MUI modals

  return (
    <Fade in={open} unmountOnExit>
      <Box
        role="status"
        aria-busy={open}
        sx={{
          position: "fixed",
          inset: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: `rgba(0,0,0,${overlayOpacity})`,
          zIndex: overlayZ,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: 2,
            px: 3,
            py: 2,
            borderRadius: 2,
            backdropFilter: "blur(4px)",
          }}
        >
          <CircularProgress sx={{ color: "#42A996" }} size={48} />
          <Typography
            variant="subtitle1"
            sx={{ color: "#ffffff", mt: 0.5, whiteSpace: "nowrap" }}
          >
            {text}
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
}

FullScreenLoader.propTypes = {
  open: PropTypes.bool,
  text: PropTypes.string,
};
